import SimpleReactValidator from "simple-react-validator";
import i18next from 'i18next';

import 'simple-react-validator/dist/locale/es';

export const repliValidator = (props) => {
    return new SimpleReactValidator({
        element: message => <>{message}</>,
        locale: i18next.language, //'en',
        ...props
    });
};